import { RecipientConst } from "@/common/recipientconstant.js";

export const StudentMergeText = [
   {
      id: 101,
      category: RecipientConst.RECIPIENT_TYPE.PUPILS,
      text: "Preferred Name",
      mergelabel: "{student_prefname}",
   },
   {
      id: 102,
      category: RecipientConst.RECIPIENT_TYPE.PUPILS,
      text: "Full Name",
      mergelabel: "{student_fullname}",
   },
];

export const ParentMergeText = [
   {
      id: 201,
      category: RecipientConst.RECIPIENT_TYPE.PARENTS,
      text: "Parent Sal Surname",
      mergelabel: "{parent_sal_surname}",
   },
   {
      id: 202,
      category: RecipientConst.RECIPIENT_TYPE.PARENTS,
      text: "Parent Sal Full Name",
      mergelabel: "{parent_sal_fullname}",
   },
];

export const CCAGroupMergeText = [
   {
      id: 501,
      category: RecipientConst.RECIPIENT_TYPE.CCA_GROUPS,
      text: "Activity Name",
      mergelabel: "{activity_name}",
   },
   {
      id: 502,
      category: RecipientConst.RECIPIENT_TYPE.CCA_GROUPS,
      text: "Teacher Name",
      mergelabel: "{teacher_name}",
   },
   {
      id: 503,
      category: RecipientConst.RECIPIENT_TYPE.CCA_GROUPS,
      text: "Student Full Name",
      mergelabel: "{student_fullname}",
   },
   {
      id: 504,
      category: RecipientConst.RECIPIENT_TYPE.CCA_GROUPS,
      text: "Parent Sal Surname",
      mergelabel: "{parent_sal_surname}",
   },
   {
      id: 505,
      category: RecipientConst.RECIPIENT_TYPE.CCA_GROUPS,
      text: "Parent Sal Full name",
      mergelabel: "{parent_sal_fullname}",
   },
   {
      id: 506,
      category: RecipientConst.RECIPIENT_TYPE.CCA_GROUPS,
      text: "Parent Full Name",
      mergelabel: "{parent_fullname}",
   },
   {
      id: 507,
      category: RecipientConst.RECIPIENT_TYPE.CCA_GROUPS,
      text: "CCA Term/Year",
      mergelabel: "{cca_termyear}",
   },
   {
      id: 508,
      category: RecipientConst.RECIPIENT_TYPE.CCA_GROUPS,
      text: "CCA Schedule Name",
      mergelabel: "{cca_schedulename}",
   },
   {
      id: 509,
      category: RecipientConst.RECIPIENT_TYPE.CCA_GROUPS,
      text: "CCA Schedule List",
      mergelabel: "{cca_schedulelist}",
   },
   {
      id: 510,
      category: RecipientConst.RECIPIENT_TYPE.CCA_GROUPS,
      text: "Cancellation Reason",
      mergelabel: "{group_cancellation_reason}",
   },
];

export const StaffMergeText = [
   {
      id: 301,
      category: RecipientConst.RECIPIENT_TYPE.STAFF,
      text: "Staff Full Name",
      mergelabel: "{staff_fullname}",
   },
];

export const VendorMergeText = [
   {
      id: 401,
      category: RecipientConst.RECIPIENT_TYPE.VENDORS,
      text: "Vendor Full Name",
      mergelabel: "{vendor_fullname}",
   },
];

export const ProposalMergeText = [
   {
      id: 601,
      category: RecipientConst.RECIPIENT_TYPE.PROPOSAL_FORM,
      text: "Proposer Name",
      mergelabel: "{proposer_name}",
   },
   {
      id: 602,
      category: RecipientConst.RECIPIENT_TYPE.PROPOSAL_FORM,
      text: "Activity Name",
      mergelabel: "{activity_name}",
   },
];
